import { SportId } from '@core/constants';

export const sportIconMap: Record<SportId, string> = {
    [SportId.Volleyball]: 'sports-volleyball',
    [SportId.Tennis]: 'sports-tennis',
    [SportId.Football]: 'sports-soccer',
    [SportId.Badminton]: 'sports-badminton',
    [SportId.TableTennis]: 'sports-table-tennis',
    [SportId.BeachVolleyball]: 'sports-volleyball-beach',
    [SportId.BeachHandball]: 'sports-beach-handball',
    [SportId.Basketball]: 'sports-basketball',
    [SportId.Handball]: 'sports-handball',
    [SportId.IceHockey]: 'sports-hockey',
    [SportId.Snooker]: 'sports-snooker',
    [SportId.CounterStrike]: 'sports-counter-strike',
    [SportId.AmericanFootball]: 'sports-american-football',
    [SportId.Box]: 'sports-boxing',
    [SportId.Mma]: 'sports-ufc',
    [SportId.Dota2]: 'sports-dota',
    [SportId.LeagueOfLegends]: 'sports-league-of-legends',
    [SportId.Darts]: 'sports-darts',
    [SportId.LandHockey]: 'sports-bandy',
    [SportId.Floorball]: 'sports-floorball',
    [SportId.Baseball]: 'sports-baseball',
    [SportId.AustralianFootball]: 'sports-afl',
    [SportId.Basketball3x3]: 'sports-basketball-3-v-3',
    [SportId.BeachFootball]: 'sports-beach-soccer',
    [SportId.Bowls]: 'sports-bocce',
    [SportId.Chess]: 'sports-chess',
    [SportId.Cricket]: 'sports-cricket',
    [SportId.Curling]: 'sports-curling',
    [SportId.Cycling]: 'sports-cycling',
    [SportId.Entertainment]: 'sports-entertainment',
    [SportId.RinkHockey]: 'sports-field-hockey',
    [SportId.FieldHockey]: 'sports-field-hockey',
    [SportId.Formula1]: 'sports-formula-1',
    [SportId.Futsal]: 'sports-futsal',
    [SportId.GaelicFootball]: 'sports-gaelic-football',
    [SportId.GaelicHurling]: 'sports-gaelic-hurling',
    [SportId.Golf]: 'sports-golf',
    [SportId.Lacrosse]: 'sports-lacrosse',
    [SportId.MotorcycleRacing]: 'sports-motorcycle-racing',
    [SportId.Motorsport]: 'games-racing-flag',
    [SportId.Netball]: 'sports-netball',
    [SportId.Netball2]: 'sports-netball',
    [SportId.Pesapallo]: 'sports-pesepallo',
    [SportId.Rugby]: 'sports-rugby',
    [SportId.Speedway]: 'sports-speedway',
    [SportId.Squash]: 'sports-squash',
    [SportId.Surfing]: 'sports-surfing',
    [SportId.Waterpolo]: 'sports-waterpolo',
    [SportId.WinterSports]: 'sports-winter-sports',
    [SportId.eSportArenaofValor]: 'sports-arena-of-valor-2',
    [SportId.eSportBasketball]: 'sports-nba-2-k',
    [SportId.eSportCallofDuty]: 'sports-cod',
    [SportId.eSportFortnite]: 'sports-fortnite',
    [SportId.eSportIceHockey]: 'sports-esports',
    [SportId.eSportKingofGlory]: 'sports-kings-of-glory',
    [SportId.eSportOverwatch]: 'sports-overwatch',
    [SportId.eSportRainbowSix]: 'sports-rainbow-six',
    [SportId.eSportRocketLeague]: 'sports-rocket-league',
    [SportId.eSportSmite]: 'sports-smite',
    [SportId.eSportFootball]: 'sports-fifa',
    [SportId.eSportStarcraft]: 'sports-starcraft',
    [SportId.eSportStarcraftII]: 'sports-starcraft-2',
    [SportId.AlpineSkiing]: 'sports-ski-jumping',
    [SportId.Kabaddi]: 'sports-soccer-stickman',
    [SportId.Padel]: 'sports-squash',
    [SportId.Padel2]: 'sports-squash',
    [SportId.FootballSpecials]: 'sports-soccer',
    [SportId.MiniFootball]: 'sports-futsal',
    [SportId.Athletics]: 'sports-athletics',
    [SportId.eSportValorant]: 'sports-valorant',
    [SportId.Olympics]: 'sports-olympics',
    [SportId.Sailing]: 'sports-sailing',
    [SportId.Swimming]: 'sports-swimming',
    [SportId.Gymnastics]: 'sports-gymnastics',
    [SportId.Judo]: 'sports-judo',
    [SportId.Taekwondo]: 'sports-taekwondo',
    [SportId.Wrestling]: 'sports-wrestling',
    [SportId.Rowing]: 'sports-rowing',
    [SportId.Fencing]: 'sports-fencing',
    [SportId.CanoeSlalom]: 'sports-canoeing',
    [SportId.CanoeSprint]: 'sports-canoeing',
    [SportId.SportClimbing]: 'sports-climbing',
};

export function getSportIconName(sportId: SportId) {
    return sportIconMap[sportId] ?? 'sports-soccer';
}
